/**
 * CUA Session API — Confirmation Response
 * Reference: TASK-UI-CU-002-1, SOL-UI-CU-002
 *
 * NOTE: @/shared/lib/api has prefixUrl: "/api". Passing "v1/..." results in "/api/v1/...".
 */

import { api } from '@/shared/lib/api';
import type { CUAConsentRequest } from '../model/types';

export interface ConfirmationResponsePayload {
  request_id: string;
  decision: 'approved' | 'rejected';
}

export async function respondToConfirmation(
  sessionId: string,
  requestId: string,
  decision: 'approved' | 'rejected'
): Promise<{ success: boolean }> {
  return api
    .post(`v1/cua/sessions/${sessionId}/confirm`, {
      json: { request_id: requestId, decision },
    })
    .json<{ success: boolean }>();
}

/**
 * Emergency stop active CUA operations
 * POST /api/v1/mcp/sessions/{id}/cua-stop
 */
export async function emergencyStop(
  sessionId: string,
  reason: string = 'user_initiated'
): Promise<{ success: boolean }> {
  return api
    .post(`v1/mcp/sessions/${sessionId}/cua-stop`, {
      json: { reason, initiated_by: 'user' },
    })
    .json<{ success: boolean }>();
}

/**
 * Record user consent for CUA access
 * POST /api/v1/cua/consent
 */
export async function recordCUAConsent(req: CUAConsentRequest): Promise<{ success: boolean }> {
  return api.post('v1/cua/consent', { json: req }).json<{ success: boolean }>();
}

